import React from "react";
import styles from "../styles/CheckboxCustom.module.scss";

export default function CheckboxCustom({
  label = "",
  checked = false,
  onChange = () => {},
  disabled = false,
}) {
  return (
    <label className={`${styles.checkboxCustom} ${disabled ? styles.disabled : ""}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={styles.hiddenInput}
      />

      <span className={`${styles.box} ${checked ? styles.checked : ""}`}>
        {checked && (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M4.5 10.5L8 14L15.5 6.5"
              stroke="#FFFFFF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>

      <span className={styles.label}>{label}</span>
    </label>
  );
}
